import * as types from './constants';

// Billing Subscription Portal
export const billingSubscriptionPortalRequest = data => (
  { type: types.BILLING_SUBSCRIPTION_PORTAL_REQUEST, payload: data }
);

export const billingSubscriptionPortalDone = data => (
  { type: types.BILLING_SUBSCRIPTION_PORTAL_DONE, payload: data }
);

export const billingSubscriptionPortalFailed = errors => (
  { type: types.BILLING_SUBSCRIPTION_PORTAL_FAILED, payload: errors }
);

export const billingSubscriptionPortalReset = () => (
  { type: types.BILLING_SUBSCRIPTION_PORTAL_RESET }
);